<template>
  <div>
    <div v-if="open" class="userInfoModal">
      <div class="userInfoModal__header">
        <div v-if="$store.getters.loading" class="loading">
          <SvgLoaderMoon> </SvgLoaderMoon>
        </div>
        <div v-else>
          <div class="userInfoModal__header-text--main">{{ user.first_name }} {{ user.last_name }}</div>
          <div class="userInfoModal__header-text--secondary">
            {{ user.company.data.name }}
          </div>
        </div>
      </div>
      <hr class="userInfoModal__header-border" />
      <div class="userInfoModal__menu">
        <div>
          <router-link
            class="userInfoModal__menu__link"
            :to="{ name: 'My Profile', params: { id: user.user_id } }"
            @click.native="closeModal()"
            >{{ $t('myProfile') }}</router-link
          >
        </div>
        <div>
          <router-link class="userInfoModal__menu__link" @click.native="closeModal()" :to="{ name: 'settings' }">{{
            $t('Settings')
          }}</router-link>
        </div>
        <div class="userInfoModal__menu--bottom">
          <div>
            <router-link class="userInfoModal__menu__link" :to="{ name: 'logout' }" @click="logout()">{{
              $t('Logout')
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="open" class="darkBg" @click="closeModal()"></div>
  </div>
</template>

<script>
import SvgUser from '../svg/SvgUser';
import SvgCompany from '../svg/SvgCompany';
import SvgLogout from '../svg/SvgLogout';
import SvgLoaderMoon from '../svg/SvgLoaderMoon';
export default {
  name: 'UserInfoModal',
  components: { SvgCompany, SvgUser, SvgLogout, SvgLoaderMoon },
  props: {
    showUserMenu: {
      default: false,
    },
  },
  data: function () {
    return {
      open: false,
    };
  },
  computed: {
    user() {
      if (!this.$store.getters.user) {
        this.$store.dispatch('tryAutoFetchAuthenticatedUser');
        console.log(this.$store.getters.user);
        return this.$store.getters.user;
      } else {
        console.log(this.$store.getters.user);
        return this.$store.getters.user;
      }
    },
  },
  watch: {
    showUserMenu: function (val) {
      this.setOpen();
    },
  },
  mounted() {
    this.setOpen();
  },
  methods: {
    selectPage(routeName) {
      this.closeModal();
    },
    closeModal: function () {
      this.open = false;
      this.$emit('close-user-menu');
    },
    setOpen: function () {
      this.open = this.showUserMenu;
    },
    logout() {
      this.$gtag.event('Logout', {
        method: 'Google',
      });
    },
  },
};
</script>

<style scoped></style>
